<div class="main-content">
  <h2>{{ 'brandLandingPage.ingress_text' | cxTranslate }}</h2>
  <div class="row no-gutters" *ngIf="{ node: node$ | async } as observables">
    <ng-container *ngFor="let links of observables.node?.children">
      <ul class="col-6 col-lg-3" *ngFor="let group of links.children">
        <ng-container *ngFor="let site of group.children">
          <cx-generic-link [url]="site.url" [target]="site.target" [title]="site.title">
            <li>
              {{ site.title }}
              <i class="reset" nz-icon nzType="arrow-right" nzTheme="outline"> </i>
            </li>
          </cx-generic-link>
        </ng-container>
      </ul>
    </ng-container>
  </div>
</div>
